module.exports = __webpack_public_path__ + "img/platform-valve-index.3ed2aebe.png";